
/*
	BrowserId is the browser-side replacement for the Mongo ObjectId, which is unavailable in the browser.

	NOTE BrowserId cannot be declared as a class. 
	Solid JS SSR performs its own serialisation using Seroval. 
	Sadly this does not support custom serialisation, although this may change. See:
		https://github.com/solidjs/solid-start/issues/1474

	Currently I perform my own serialisation of ObjectIds for SSR in createRouter.ts 
	(NOTE there are 2 serialisers - the SSR one and the main RPC one).
	The problem comes with deserialisation. The SSR sprays the hydrated data all around
	so there is not easy point at which to deserialise the data).
*/

import type { ObjectId } from 'mongodb';

export type BrowserId = {
	_browserId: string
};

export type BrowserOrServerId = BrowserId | ObjectId;

export function isBrowserId(obj:any)
{
	return obj?._browserId != null;
}

export function browserId(value:string): BrowserId
{
	return {_browserId: value};
}

export function sameId(a:BrowserOrServerId,b:BrowserOrServerId)
{
	if (!a || !b)
		return false;

	if (isBrowserId(a))
		return (<BrowserId>a)._browserId == (<BrowserId>b)._browserId;

	return (<ObjectId>a).equals(<ObjectId>b);
}

export function idString(id:BrowserOrServerId) 
{
	if (isBrowserId(id))
		return (<BrowserId>id)._browserId;

	return id.toString();
}

